const wireTransferTranslations = {
  typeOfPayment: {
    label: "Art der Zahlung",
    values: {
      standard: "Normale Zahlung",
      thirdPartyFunds: "Fremdgeld",
      caseUnrelated: "Nicht am Fall buchen",
      feeRefund: "Gebührenrückerstattung",
    },
  },
  wireTransferTemplates: {
    other: "Sonstige Überweisung",
    feePayment: "Gebührenbegleichung (REA Gericht/Melderegister)",
    thirdPartyFunds: "Fremdgeld",
    expenses: "Expenses",
    creditNoteCourtAdvancePayment: "Rückzahlung GKV an RSV",
    creditNoteSurplusFinalPaymentInsurer: "Rückzahlung Überschuss aus Abschlussrechnung an RSV",
    creditNoteSurplusFinalPaymentClient: "Rückzahlung Überschuss aus Abschlussrechnung an Mandantschaft",
    creditNoteFeesInsurer: "Rückzahlung Gebühren an RSV",
    creditNotePartnerFeeInsurer: "Rückzahlung Partnerpauschale an RSV",
    creditNoteLawyerInvoice: "Begleichung LBRA Rechnung (nicht fallbezogen)",
    nonAdvoAssistRepresentativeInvoice: "Begleichung TV Rechnung (abseits von AdvoAssist)",
  },
};
export default wireTransferTranslations;
